import { Widget } from "@foretagsplatsen/widgetjs";
import ReportStatusIcon from "./ReportStatusIcon.js";
import theme from "../../../core/theme.js";

/**
 * `periodReportArchiveIconWidget` renders a period report as a big icon (à
 * la document archive).
 *
 * @param {periodReport} spec.report - `periodReport` to render
 * @param {boolean} [spec.selected=false] - True if the report is the currently selected one
 */
export default class PeriodReportArchiveIconWidget extends Widget {
	constructor(spec) {
		super(spec);

		this._report = spec.report;
		this._selected = spec.selected;
		this._canSeePeriodReportViewers = spec.canSeePeriodReportViewers;

		this.onSelect = this._events.createEvent();
	}

	renderContentOn(html) {
		const selectedClass = this._selected ? " active" : "";
		const withdrawnClass = this._report.isWithdrawn() ? " withdrawn" : "";
		const draftClass = this._report.isDraft() ? " draft" : "";
		const cssClass = `fp-icon period-report-icon${selectedClass}${withdrawnClass}${draftClass}`;

		const statusIcon = this._canSeePeriodReportViewers
			? new ReportStatusIcon({
					reportSummary: this._report,
				})
			: "";

		html.div(
			{
				klass: cssClass,
				click: this._handleClick.bind(this),
				"data-test": "period-report-icon",
			},
			(html) => {
				if (!theme.agencyLogo) {
					return;
				}

				html.img({
					klass: "icon-logo-overlay",
					src: theme.agencyLogo,
				});
			},
			html.a(
				{
					"data-test": "name",
					href: this._linkTo(this._getLinkTarget(), {
						id: this._report.getId(),
					}),
				},
				this._report.getTitle(),
				statusIcon,
			),
		);
	}

	_getLinkTarget() {
		return this._report.isDraft() ? "edit-period-report" : "period-report";
	}

	_redirectToReport() {
		this._redirectTo(this._getLinkTarget(), { id: this._report.getId() });
	}

	_handleClick() {
		if (this._selected) {
			this._redirectToReport();
		} else {
			this.onSelect.trigger(this._report);
		}
	}
}
